<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>
           
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="expand-all"
                                name="nombre"
                                v-model="form.nombre"
                                :label="$t('deposito.labels.nombre')"
                                :placeholder="$t('deposito.labels.nombre')"
                                :error="hasInputErrors('nombre')"
                                :error-messages="getInputErrors('nombre')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>
    
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="map-marker"
                                name="direccion"
                                v-model="form.direccion"
                                :label="$t('deposito.labels.direccion')"
                                :placeholder="$t('deposito.labels.direccion')"
                                :error="hasInputErrors('direccion')"
                                :error-messages="getInputErrors('direccion')"
                                color="secondary"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-textarea
                                
                                prepend-icon="text-subject"
                                name="descripcion"
                                v-model="form.descripcion"
                                :label="$t('deposito.labels.descripcion')"
                                :placeholder="$t('deposito.labels.descripcion')"
                                :error="hasInputErrors('descripcion')"
                                :error-messages="getInputErrors('descripcion')"
                                color="secondary"
                                rows="3"
                        ></v-textarea>
                    </v-col>
    
        </v-row>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    
    


    

    export default {
        name: "DepositoForm",
        mixins: [InputErrorsByProps, RequiredRule    ],
        
        props:{
            value: {
                type: Object,
                required: true
            },
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
         watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            }
        },
        data(){
            return {
                
            }
        }
    }
</script>

<style scoped>

</style>



